import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["number", "numberButton", "cvc", "cvcButton"]
  static values = { number: String, last4: String, cvc: String }

  toggleNumber() {
    const showing = this.numberButtonTarget.ariaPressed === "true"
    this.numberTarget.textContent = showing ? this.maskedNumber : this.formattedNumber
    this.updateButton(this.numberButtonTarget, "card number", !showing)
  }

  toggleCvc() {
    const showing = this.cvcButtonTarget.ariaPressed === "true"
    this.cvcTarget.textContent = showing ? "•••" : this.cvcValue
    this.updateButton(this.cvcButtonTarget, "CVC", !showing)
  }

  get formattedNumber() {
    return this.numberValue.match(/.{1,4}/g)?.join(" ") || this.numberValue
  }

  get maskedNumber() {
    return `${this.numberValue.slice(0, 4)} •••• •••• ${this.last4Value}`
  }

  updateButton(button, label, showing) {
    button.ariaPressed = showing.toString()
    button.ariaLabel = `${showing ? "Hide" : "Show"} ${label}`
  }
}